/**
 *  @fileOverview Lead Gen Module, initialise and generate lead gen forms
 *
 *  @author       Aaron Chapman
 *
 */

function LeadGenModule (axios, Pristine, sha256) {
  /**
   * @description Initialises lead gen form instances.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  let leadGenSection = document.querySelector('.leadGen')
  let leadGenCourse = document.querySelector('.leadGen--course')
  let formButtons = ''
  let leadGenCourseForm = null
  let pristine
  let downloadPath = ''
  if (leadGenSection !== null) {
    formButtons = leadGenSection.querySelector('.leadGen__initial')
  }

  if (leadGenCourse !== null) {
    leadGenCourseForm = leadGenCourse.querySelector('.leadGen__formWrapper').cloneNode(true)

    /// If the lead gen course form exists on page we will need to change the enquire href
    let enquireBtns = document.querySelectorAll('.button[data-action="enquire"]')

    // Loop through all buttons and change the href to anchor to lead gen form
    enquireBtns.forEach(enquireBtn => {
      enquireBtn.href = '#leadGen--course'
    })
  }

  let url = 'https://cloud.mc.ecu.edu.au/fs-study-opps-leadgen'

  if (process.env.NODE_ENV !== 'production') {
    url = 'https://cloud.mc.ecu.edu.au/dev-fs-study-opps-leadgen'
  }

  this.init = function () {
    if (leadGenSection !== null & leadGenCourse === null) {
      createFormButtons()
    } else if (leadGenCourse !== null) {
      url = 'https://webservices.web.ecu.edu.au/salesforce/lead-processor.php'

      if (process.env.NODE_ENV !== 'production') {
        url = 'https://webservicesdev.web.ecu.edu.au/salesforce/lead-processor.php'
      }

      let leadGenForm = document.querySelector('.leadGen__form')

      let urlVars = getUrlVars()
      let utmSource = ''
      let utmMedium = ''
      let utmCampaign = ''
      let utmContent = ''
      let gclid = ''

      if (urlVars['utm_source'] !== undefined) {
        utmSource = urlVars['utm_source']
      }
      if (urlVars['utm_medium'] !== undefined) {
        utmMedium = urlVars['utm_medium']
      }
      if (urlVars['utm_campaign'] !== undefined) {
        utmCampaign = urlVars['utm_campaign']
      }
      if (urlVars['utm_content'] !== undefined) {
        utmContent = urlVars['utm_content']
      }
      if (urlVars['gclid'] !== undefined) {
        gclid = urlVars['gclid']
      }

      document.getElementById('UTM_Source__c').value = utmSource
      document.getElementById('UTM_Medium__c').value = utmMedium
      document.getElementById('UTM_Campaign__c').value = utmCampaign
      document.getElementById('UTM_Content__c').value = utmContent

      if (document.getElementById('GCLID__c') !== null) {
        document.getElementById('GCLID__c').value = gclid
      }

      pristine = new Pristine(leadGenForm)

      leadGenForm.addEventListener('submit', submitForm)
    }
  }

  let createFormButtons = function () {
    let formButtons = leadGenSection.querySelectorAll('.button--leadGen') // Get all buttons with leadGen modifiers indicating they have forms

    Array.from(formButtons).forEach(formButton => {
      formButton.addEventListener('click', createForm)
    })
  }

  let submitForm = function (event) {
    event.preventDefault()

    if (document.getElementById('emailOptOut').checked) {
      document.getElementById('hiddenOpt').setAttribute('disabled', 'disabled')
    }

    let leadGenForm = leadGenSection.querySelector('.leadGen__form')

    let submitBtn = leadGenForm.querySelector('input[type=submit]')

    var valid = pristine.validate()

    if (valid) {
      submitBtn.value = 'Processing...'
      submitBtn.setAttribute('disabled', 'disabled')

      if (leadGenCourse !== null) {
        let emailField = document.getElementById('email').value
        let hashedEmail = sha256(emailField).toString()

        window.dataLayer.push({
          'ECU': {
            'userDetails': {
              'hashedEmail': hashedEmail
            }
          },
          'event': 'leadGenCourseSubmit'
        })
      } else {
        /// We are inside brochure lead gen form trigger GTM custom event
        window.dataLayer.push({
          'event': 'leadGenBrochureSubmit',
          'leadGenBrochureWebPath': downloadPath.replace(/^(https?:|)\/\//, '')
        })
      }

      axios.post(url, serialize(leadGenForm))
        .then(function (response) {
          // Trim whitespace, them slice the () returned from SF and parse as JSON so we can access the outcome
          if (response.data.outcome.includes('failed')) {
            if (leadGenCourse == null) {
              window.dataLayer.push({
                'event': 'leadGenBrochureResponse',
                'leadGenResponse': 'failed'
              })
            } else {
              window.dataLayer.push({
                'leadGenResponse': 'failed'
              })
            }
            loadDownload()
          } else {
            if (leadGenCourse == null) {
              window.dataLayer.push({
                'event': 'leadGenBrochureResponse',
                'leadGenResponse': 'success'
              })
            } else {
              window.dataLayer.push({
                'leadGenResponse': 'success'
              })
            }
            loadConfirmation()
          }
        })
        .catch(function (error) {
          loadError(error)
        })
    }
  }

  /*!
   * Serialize all form data into a query string
   * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */

  let serialize = function (form) {
    // Setup our serialized data
    let serialized = []

    // Loop through each field in the form
    for (let i = 0; i < form.elements.length; i++) {
      let field = form.elements[i]
      // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
      if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue

      // If a multi-select, get all selections
      if (field.type === 'select-multiple') {
        for (let n = 0; n < field.options.length; n++) {
          if (!field.options[n].selected) continue
          serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[n].value))
        }
      } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
        serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value))
      }
    }

    return serialized.join('&')
  }

  let loadConfirmation = function () {
    let formMarkup = leadGenSection.querySelector('.leadGen__form')
    formMarkup.remove()

    let formConfirmation = `
      <div class="leadGen__confirmation">
        <h2 class="base__heading base__heading--sectionHeading base__heading--small">Hey, thanks for checking us out.</h2>
        <p class="base__lead">If you have any questions after reading the brochure in your inbox, please get in touch.</p>
        <button class="leadGen__close" aria-label="Close panel"><i title="close panel" class="fas fa-times fa-2x"></i></button>
      </div>`

    if (leadGenCourse !== null) {
      formConfirmation = `
      <div class="leadGen__confirmation">
        <h2 class="base__heading base__heading--sectionHeading base__heading--small">Thanks for your enquiry.</h2>
        <button class="leadGen__close" aria-label="Close panel"><i title="close panel" class="fas fa-times fa-2x"></i></button>
      </div>`
    }

    leadGenSection.innerHTML = formConfirmation

    if (leadGenCourse === null) {
      createCloseButtons(formButtons)
    } else {
      createCloseButtons(leadGenCourseForm)
    }
  }

  let loadDownload = function () {
    let formMarkup = leadGenSection.querySelector('.leadGen__form')
    formMarkup.remove()

    let formConfirmation = `
      <div class="leadGen__confirmation">
        <h2 class="base__heading base__heading--sectionHeading base__heading--small">Hey, thanks for checking us out.</h2>
        <p class="base__lead">
          If you have any questions after downloading the brochure, please get in touch.<br><br>
          <a href="${downloadPath}" class="button button--dark">Download brochure &nbsp;<i class="button__formIcon fas fa-download fa-lg"></i></a>
        </p>
        <button class="leadGen__close" aria-label="Close panel"><i title="close panel" class="fas fa-times fa-2x"></i></button>
      </div>`
    leadGenSection.innerHTML = formConfirmation

    if (leadGenCourse === null) {
      createCloseButtons(formButtons)
    } else {
      createCloseButtons(leadGenCourseForm)
    }
  }

  let loadError = function (error) {
    let formMarkup = leadGenSection.querySelector('.leadGen__form')
    formMarkup.remove()

    let formError = `
      <div class="leadGen__confirmation">
        <h2 class="base__heading base__heading--sectionHeading base__heading--small">Error on submission</h2>
        <p class="base__lead">Sorry, your form was not submitted correctly.</p>
        <p>${error}</p>
        <button class="leadGen__close" aria-label="Close panel"><i title="close panel" class="fas fa-times fa-2x"></i></button>
      </div>`
    leadGenSection.innerHTML = formError

    if (leadGenCourse === null) {
      createCloseButtons(formButtons)
    } else {
      createCloseButtons(leadGenCourseForm)
    }
  }

  let createForm = function (event) {
    event.preventDefault()
    formButtons.remove()
    downloadPath = this.getAttribute('href')

    /// Push custom event to GTM to trigger form init
    window.dataLayer.push({
      'event': 'leadGenBrochureInitialise'
    })

    let urlVars = getUrlVars()
    let utmSource = ''
    let utmMedium = ''
    let utmCampaign = ''
    let utmContent = ''
    let utmTerm = ''
    let studyArea = ''

    let campaignType = document.querySelector('meta[name="marketing.campaign-type"]').content
    let campaignName = document.querySelector('meta[name="marketing.campaign-name"]').content
    let campaignId = document.querySelector('meta[name="marketing.campaign-id"]').content

    if (window.dataLayer[0].ECU.studyDetails !== undefined) {
      studyArea = window.dataLayer[0].ECU.studyDetails.studyArea.replace(/\s+/g, '-').replace(/&/g, 'and').toLowerCase()
    }
    utmTerm = 'leadGen-fs-brochure-' + studyArea

    if (urlVars['utm_source'] !== undefined) {
      utmSource = urlVars['utm_source']
    }
    if (urlVars['utm_medium'] !== undefined) {
      utmMedium = urlVars['utm_medium']
    }
    if (urlVars['utm_campaign'] !== undefined) {
      utmCampaign = urlVars['utm_campaign']
    }
    if (urlVars['utm_content'] !== undefined) {
      utmContent = urlVars['utm_content']
    }

    let form = `
      <div class="leadGen__formWrapper">
        <h2 class="base__heading base__heading--sectionHeading base__heading--small">Request a brochure</h2>
        <h3 class="base__subheading">Enter your details</h3>
        <form class="leadGen__form" action="#">
          <input type="hidden" name="CampaignType" value="${campaignType}">
          <input type="hidden" name="CampaignName" value="${campaignName}">
          <input type="hidden" name="CampaignId" value="${campaignId}">
          <input type="hidden" name="UTM_Source__c" value="${utmSource}">
          <input type="hidden" name="UTM_Medium__c" value="${utmMedium}">
          <input type="hidden" name="UTM_Campaign__c" value="${utmCampaign}">
          <input type="hidden" name="UTM_Content__c" value="${utmContent}">
          <input type="hidden" name="UTM_Term__c" value="${utmTerm}">
          <div class="form-group">  
            <label class="visuallyHidden" for="first_name">Name</label>
            <input type="text" class="leadGen__input" name="first_name" value="" placeholder="First Name" required maxlength="40">
          </div>
          <div class="form-group">
            <input type="text" class="leadGen__input form-control" name="last_name" value="" placeholder="Last Name" required maxlength="80">
          </div>
          <div class="form-group">
            <label class="visuallyHidden" for="email">Email</label>
            <input type="email" class="leadGen__input form-control" name="email" value="" placeholder="Email" required>
          </div>
          <div class="form-group">
            <label class="visuallyHidden" for="mobile">Phone Number (optional)</label>
            <input type="tel" class="leadGen__input  form-control" name="mobile" value="" placeholder="Mobile (optional)">
          </div>
          <div class="checkbox leadGen__checkbox">
            <input type="hidden" name="emailOptOut" id="hiddenOpt" value='1'/>
            <input type="checkbox" name="emailOptOut" id="emailOptOut" value="0" checked>
            <label for="emailOptOut">Im happy to receive futher communications about future study opportunities from ECU.<br>You can update your preference at any time from ECU comminications sent to you.</label>
          </div>
          <div class="leadGen__button">
            <input type="submit" class="button button--dark button--leadGenSubmit" value="Request Brochure"><i class="button__formIcon fas fa-download fa-lg"></i>
          </div>
        </form>
        <button class="leadGen__close" aria-label="Close panel"><i title="close panel" class="fas fa-times fa-2x"></i></button>
      </div>`
    leadGenSection.innerHTML = form

    let leadGenForm = leadGenSection.querySelector('.leadGen__form')

    pristine = new Pristine(leadGenForm)

    leadGenForm.addEventListener('submit', submitForm)

    createCloseButtons(formButtons)
  }

  let closeForm = function (content) {
    leadGenSection.innerHTML = content.outerHTML
    if (leadGenCourse === null) {
      createFormButtons()
    } else {
      let leadGenForm = document.querySelector('.leadGen__form')
      leadGenForm.addEventListener('submit', submitForm)
    }
  }

  let getUrlVars = function () {
    let vars = {}
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value
    })
    return vars
  }

  let createCloseButtons = function (content) {
    let leadGenCloseButtons = leadGenSection.querySelectorAll('.leadGen__close')
    Array.from(leadGenCloseButtons).forEach(closeButton => {
      closeButton.addEventListener('click', function () {
        closeForm(content)
      })
    })
  }
}

module.exports = LeadGenModule
